import { Keyword, Transform } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
const parse = either(Keyword.parse("none"), Transform.parseList);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform}
 * @internal
 */
export default Longhand.of(Keyword.of("none"), parse, (transform, style) => transform.map((transform) => Keyword.isKeyword(transform)
    ? transform
    : transform.map(Transform.partiallyResolve(Resolver.length(style)))));
//# sourceMappingURL=transform.js.map